import { lazy } from 'react';
import { Navigate } from 'react-router-dom';

// project imports
import Loadable from 'ui-component/Loadable';

// login option 3 routing
const AuthLogin = Loadable(lazy(() => import('views/pages/authentication/authentication3/Login3')));
const AuthLoginAdmin = Loadable(lazy(() => import('views/pages/authentication/authentication3/LoginAdmin')));
const LoginOptions = Loadable(lazy(() => import('views/pages/authentication/authentication3/LoginOptions')));

import OperatorHeader from '../ui-component/header/OperatorHeader';

// ==============================|| AUTHENTICATION ROUTING ||============================== //

const AuthenticationRoutes = {
    path: '/',
    element: <OperatorHeader />,
    children: [
        {
            path: '/',
            element: <LoginOptions />
        },
        {
            path: '/auth',
            element: <AuthLogin />
        },
        {
            path: '/auth-admin',
            element: <AuthLoginAdmin />
        },
        {
            path: '*',
            element: <LoginOptions />
        }
    ]
};

export default AuthenticationRoutes;
